import React from "react";
import styled from "styled-components";
import { UploadedFileItem } from "../UploadedFileItem/UploadedFileItem";
import { Typography } from "../../general/Typography";
import { Flex } from "../../layouts/wrappers/Flex";

export interface UploadedFile {
  name: string;
  size?: number;
}

interface MaterialUploadListProps {
  files: UploadedFile[];
  onRemove: (index: string | number) => void;
  title?: string;
}

const ListWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const MaterialUploadList: React.FC<MaterialUploadListProps> = ({
  files,
  onRemove,
  title = "Uploaded Files",
}) => {
  if (files.length === 0) return null;

  return (
    <ListWrapper>
      <Typography variant="body">{title}</Typography>
      {files.map((file, index) => (
        <UploadedFileItem
          key={index}
          fileName={file.name}
          fileSize={file.size}
          onRemove={() => onRemove(index)}
        />
      ))}
    </ListWrapper>
  );
};